const faqItems = [
  {
    q: '51吃瓜最新网址是什么类型的网站？',
    a: '51吃瓜最新网址是一个专注于娱乐圈、网红圈及社会热点领域的吃瓜爆料聚合平台。我们每日追踪并汇总最新的51吃瓜爆料、黑料实锤与热门话题，提供51吃瓜今日黑料视频及爆料合集，是广大吃瓜群众的资讯第一站。',
  },
  {
    q: '网站上的爆料内容是否真实可靠？',
    a: '本站内容来源于公开网络信息的多方汇总与整理，力求为读者提供全面、及时的事件全貌。所有51吃瓜黑料汇总均标注信息来源，建议理性看待，多角度了解事件真相。',
  },
  {
    q: '如何第一时间获取最新的51吃瓜爆料？',
    a: '本站每日持续更新，您可以将51吃瓜最新网址加入收藏夹，或关注页面上方的热门爆料与焦点专题板块。我们坚持每日更新，确保你不错过任何一条重磅51吃瓜最新爆料。',
  },
  {
    q: '可以在51吃瓜最新网址投稿或提供线索吗？',
    a: '欢迎通过页面下方的"联系我们"板块与我们取得联系。如果您有独家爆料线索或内容建议，我们非常乐意接收并评估，共同打造更全面的51吃瓜爆料网内容生态。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          常见问答
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
          关于51吃瓜最新网址的常见问题解答
        </p>
        <div className="flex flex-col gap-4">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}